import client from "@/libs/client.ts";
import type { TransactionResource } from "@/factories/TransactionFactory.ts";
import TransactionRequest from "@/requests/TransactionRequest.ts";
import type Transaction from "@/classes/Transaction.ts";
import type { DateRange } from "@/types/date";

const create = async (
  tx: Transaction,
  type: "expense" | "income",
  dateRange: DateRange,
): Promise<TransactionResource> => {
  const response = await client.post(
    `account/transactions/${type}`,
    new TransactionRequest(tx, dateRange),
  );

  if (response.status !== 201) {
    throw new Error("Invalid transaction");
  }

  return response.data.data;
};

const fetch = async (id: number): Promise<TransactionResource> => {
  const response = await client.get(`account/transactions/${id}`);

  return response.data.data;
};

const fetchAll = async (dateRange: DateRange): Promise<TransactionResource[]> => {
  const response = await client.get(
    `account/transactions?from=${dateRange.from.format("YYYY-MM-DD")}&to=${dateRange.to.format("YYYY-MM-DD")}`,
  );

  return response.data.data;
};

const remove = async (tx: Transaction): Promise<boolean> => {
  const response = await client.delete(`account/transactions/${tx.id}`);

  return response.status === 204;
};

const toggle = async (id: number): Promise<boolean> => {
  const response = await client.patch(`account/transactions/${id}`);

  return response.data.data.is_disabled;
};

const update = async (
  tx: Transaction,
  dateRange: DateRange,
): Promise<TransactionResource | TransactionResource[]> => {
  const response = await client.put(
    `account/transactions/${tx.id}`,
    new TransactionRequest(tx, dateRange),
  );

  if (response.status !== 201) {
    throw new Error("Invalid transaction");
  }

  return response.data.data;
};

export { create, fetch, fetchAll, remove, toggle, update };
